/**
 * Pure, platform-free fallback used until `configureMediaPreferences` runs (or in a test
 * harness that never calls it). Touches no browser global, so it's safe to define inside
 * `client/ui` itself (boundary rule B2).
 *
 * Both defaults are `false` deliberately, and they are NOT the same kind of "off":
 * `prefersReducedMotion: false` means the FULL animated experience (the original skin only
 * suppresses motion on an explicit match), while `hasFinePointer: false` means hover-open
 * affordances stay inert. In each case `false` is the behavior that degrades safely when
 * nothing has been registered.
 */
const NOOP_MEDIA_PREFERENCES = {
    prefersReducedMotion: () => false,
    hasFinePointer: () => false,
};
let activeMediaPreferences = NOOP_MEDIA_PREFERENCES;
/**
 * Registers the real `MediaPreferencesPort` implementation. Mirrors
 * `shell/theme-environment.ts`'s `configureThemeEnvironment` exactly — a module-level slot
 * inside `client/ui`, populated once by the composition root (`system/pwa/src/main.ts`, via
 * `createBrowserMediaPreferences()` from `@econ-v1/adapters-web`) before
 * `<node-app-shell>` is inserted into the document, so `shell/pmenu.ts`'s
 * `connectedCallback` and the waves stage's `mount` read the real environment the very
 * first time they run. `client/ui` itself never references `matchMedia`; only the injected
 * port does.
 */
export function configureMediaPreferences(preferences) {
    activeMediaPreferences = preferences;
}
/** Read by the shell/stage call sites as their default `preferences` argument — exported
 * separately so tests can pass a fake directly instead of mutating this shared singleton. */
export function currentMediaPreferences() {
    return activeMediaPreferences;
}
//# sourceMappingURL=media-preferences.js.map